import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import { useRouter } from 'vue-router';
import TheAction from './TheAction.vue';
const __default__ = {
  name: 'Channel'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const router = useRouter();
    const headerConfig = ref({
      title: '频道分类',
      btnList: [{
        label: '返回',
        func: () => {}
      }]
    });
    const tableConfig = reactive({
      data: [{
        name: 'test',
        sort: '23'
      }],
      showPageBar: false,
      isShowHeader: true,
      listName: '频道分类',
      headerButtonsList: [{
        label: '添加',
        func: () => {
          dialogConfig.visible = true;
        }
      }, {
        label: '删除',
        func: () => {}
      }, {
        label: '节目数量更新',
        func: () => {}
      }, {
        label: '自动排序',
        func: () => {}
      }],
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        minWidth: '5%'
      }, {
        label: '分类名称',
        prop: 'name',
        minWidth: '15%'
      }, {
        label: '类型',
        prop: 'type',
        minWidth: '10%'
      }, {
        label: '分类等级',
        prop: 'grade',
        minWidth: '10%'
      }, {
        label: '状态',
        prop: 'status',
        minWidth: '5%'
      }, {
        label: '排序',
        prop: 'sort',
        minWidth: '5%',
        widgetType: 'doubleInput',
        valueChange: (value, done) => {
          console.log(value);
        }
      }, {
        label: '节目总数',
        prop: 'total',
        minWidth: '5%'
      }, {
        label: '描述',
        prop: 'description',
        minWidth: '15%'
      }, {
        label: '操作',
        prop: '',
        minWidth: '20%',
        widgetType: 'buttons',
        buttonsList: [{
          label: '修改',
          func: () => {
            dialogConfig.visible = true;
          }
        }, {
          label: '内容列表',
          func: () => {
            router.push('/operating/product-operating/channel/channel-content');
          }
        }, {
          label: '添加子分类',
          func: () => {}
        }, {
          label: '删除',
          func: () => {}
        }]
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      config: {
        title: '添加分类'
      }
    });
    return (_ctx, _cache) => {
      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(ActionHeader, {
        config: headerConfig.value
      }, null, 8, ["config"]), _createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.visible = $event),
        dialogConfig: dialogConfig.config
      }, {
        default: _withCtx(() => [_createVNode(TheAction)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig"])]);
    };
  }

});